<template>
  <LayoutBasic :showLinksMenu="false">
    <template v-slot:navigation-title>
      <span class="white--text font-weight-black text-h4">Ventas</span>
    </template>

    <template v-slot:navigation-content>
      <v-list nav dense class="mt-4 px-0" background-color="transparent">
        <v-list-item-group v-model="item" color="blue lighten-2">
          <v-list-item
            v-for="(link, i) in links"
            :key="i"
            @click="$router.push({ name: link.routeName })"
            class="nexus-nav-item mb-2"
          >
            <v-list-item-icon class="mr-4">
              <v-icon size="20">{{ link.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-medium">
                {{ link.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>

        <v-divider class="grey darken-4 my-4"></v-divider>

        <v-list-item @click="sheet = !sheet" class="nexus-nav-item-alt">
          <v-list-item-icon class="mr-4">
            <v-icon color="grey lighten-1" size="20">mdi-chart-line</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="grey--text text--lighten-1 font-weight-medium">
              Facturado
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </template>

    <template v-slot:vista-previa>
      <router-view></router-view>

      <v-bottom-sheet v-model="sheet" inset>
        <v-sheet class="text-center nexus-sheet" height="150px">
          <v-container>
            <div class="grey--text text-uppercase font-weight-black text-caption mb-2">
              Reporte en Cajón
            </div>
            <div class="white--text text-h3 font-weight-black mt-2">
              {{ total_vendido_blanco.total | convertPesoArg }}
            </div>
            <v-btn text color="blue lighten-2" class="mt-4" @click="sheet = false">
              Cerrar
            </v-btn>
          </v-container>
        </v-sheet>
      </v-bottom-sheet>
    </template>
  </LayoutBasic>
</template>

<script>
import LayoutBasic from "@/layouts/LayoutBasic.vue";
import { mapActions, mapState } from "vuex";

export default {
  name: "VentasHome",
  components: {
    LayoutBasic,
  },
  filters: {
    convertPesoArg(value) {
      if (!value) return "$ 0";
      return `$ ${new Intl.NumberFormat("de-DE").format(value)}`;
    },
  },
  data() {
    return {
      item: 0,
      links: [],
      sheet: false,
    };
  },
  computed: {
    ...mapState("sucursales", ["configuracion"]),
    ...mapState("comprobantes", ["total_vendido_blanco"]),
  },
  methods: {
    ...mapActions("comprobantes", [
      "get_total_ventas_blanco",
      "fetch_formas_de_pago",
    ]),
  },
  created() {
    this.fetch_formas_de_pago();
    this.get_total_ventas_blanco();
    
    this.links = [
      { text: "Inicio", icon: "mdi-view-dashboard-outline", routeName: "ventas" },
      { text: "Nueva venta", icon: "mdi-cart-plus", routeName: "pos.venta.registrar" },
      { text: "Consultar", icon: "mdi-magnify", routeName: "pos.venta.consultar" }
    ];

    if (this.configuracion?.ventaConPedido) {
      this.links.push({
        text: "Pedidos",
        icon: "mdi-clipboard-text-clock-outline",
        routeName: "pos.venta.pedidos",
      });
    }
  },
};
</script>

<style lang="scss" scoped>
/* Estilo para los ítems de navegación */
.nexus-nav-item {
  border-radius: 8px !important;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: rgba(255, 255, 255, 0.05);
  }
}

.nexus-nav-item-alt {
  border-radius: 8px !important;
  border: 1px dashed rgba(255, 255, 255, 0.1) !important;
}

/* Estilo para el Bottom Sheet */
.nexus-sheet {
  background-color: #121212 !important;
  border-top-left-radius: 20px !important;
  border-top-right-radius: 20px !important;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}
</style>